"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var requireComponent = require.context('./modules', true, /.*\.vue$/);
var register = {};
requireComponent.keys().forEach(function (fileName) {
  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  if (fileName.split('/').length === 3) {
    var componentConfig = requireComponent(fileName);
    var componentName = fileName.substring(2, fileName.length - 4).split('/').map(function (item) {
      return item === 'index' ? '' : capitalizeFirstLetter(item);
    }).join('');
    register[componentName] = componentConfig.default || componentConfig;
  }
});
var _default = exports.default = register;